/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ResolveType } from "./ResolveType";
import { ResolveTo } from "./ResolveTo";
import { RemovedFromMainResolution } from "./RemovedFromMainResolution";
export const Resolve = core.serialization.object({
    field: core.serialization.string().optional(),
    type: ResolveType.optional(),
    resolveTo: ResolveTo.optional(),
    clipValueReference: core.serialization.property("clip_value_reference", core.serialization.string().optional()),
    mainValueReference: core.serialization.property("main_value_reference", core.serialization.string().optional()),
    removedFromMainResolution: RemovedFromMainResolution.optional(),
});
